import { Component, ViewEncapsulation } from '@angular/core';
import { OffCanvasChildComponent } from '../../model/off-canvas-child-component';
import { OffCanvasService } from '../../services';

@Component({
    templateUrl: './info-select-game.component.html',
    encapsulation: ViewEncapsulation.None
})
export class InfoSelectGameComponent extends OffCanvasChildComponent
{
    public constructor(offCanvasService: OffCanvasService)
    {
        super(offCanvasService);
    }
}

